import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {withStyles} from '@material-ui/core/styles';
import {AnimationRotate} from './Style'
import { IoIosArrowForward} from "react-icons/io";

class TableHeadEvent extends React.Component {
  constructor(props){
      super(props);
      this.state = {
      }
    }

    _renderCell = (Name, Trad, classes, none) => {
      if (none)
      {
        return (
          <div style={{display: 'flex', flexDirection: 'row', fontSize: "0.85em", color: 'black', fontWeight: 'bold'}}>
            <p>{Trad}</p>
            <div style={{marginLeft: 5}}>
              <IoIosArrowForward  color={'rgba(0,0,0,0)'} size={15} />
            </div>
          </div>
        )
      }
      return (
        <div onClick={() => this.props.refParent._sortByAlphabet(Name)} style={{display: 'flex', flexDirection: 'row', fontSize: "0.85em", color: 'black', fontWeight: 'bold'}}>
          <p>{Trad}</p>
          <div style={{marginLeft: 5}}>
            <IoIosArrowForward className={this.props.refParent.state.sortFilter[Name] === 'down' ? classes.spin : classes.refresh} color={'black'} size={15} />
          </div>
        </div>
      )
    }

 render() {
   const { classes } = this.props

   return (
      <TableHead>
        <TableRow>
          <TableCell align="left">{this._renderCell("FirstName", 'PRENOM', classes, true)}</TableCell>
          <TableCell align="left">{this._renderCell("LastName", 'NOM', classes)}</TableCell>
          <TableCell align="left">{this._renderCell("Email", 'E-MAIL', classes)}</TableCell>
          <TableCell align="left">{this._renderCell("Society", 'SOCIETE', classes)}</TableCell>
          <TableCell align="left">{this._renderCell("Function", 'FONCTION', classes, true)}</TableCell>
          <TableCell align="left">{this._renderCell("Date", "DATE", classes)}</TableCell>
          <TableCell align="left">{this._renderCell("Source", "SOURCE", classes)}</TableCell>
          <TableCell align="left">{this._renderCell("MemberStatus", "MEMBRE", classes)}</TableCell>
          {
            this.props.isFree ?
            <>
            </>
            :
            <>
            <TableCell align="left">{this._renderCell("UrlPayment", "URL", classes, true)}</TableCell>
            <TableCell align="left">{this._renderCell("StatusSubscribe", "STATUS", classes, true)}</TableCell>
            </>
          }
          <TableCell align="center"><div style={{fontSize: 15, fontFamily: 'Mitr, sans-serif', color: 'black', fontWeight: 'bold'}}>{this._renderCell("Cotisation", 'COTISATION', classes, true)}</div></TableCell>
          <TableCell align="center"><div style={{fontSize: 15, fontFamily: 'Mitr, sans-serif', color: 'black', fontWeight: 'bold'}}>{this._renderCell("Action", 'ACTION', classes, true)}</div></TableCell>
        </TableRow>
      </TableHead>

   )
 }
}


export default withStyles(AnimationRotate)(TableHeadEvent);
